
export { Widget } from "./widget.interfaces"